import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scene-components-popover',
  templateUrl: './scene-components-popover.component.html',
  styleUrls: ['./scene-components-popover.component.scss'],
})
export class SceneComponentsPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
